export const getAnswer = answerField => {
    let answerValue = '';
    if (answerField && answerField.values && answerField.values.length > 0) {
        for (let v = 0; v < answerField.values.length; v++) {
            const theValue = answerField.values[v];
            if (theValue.origin) {
                const origin = theValue.origin.toString();
                if ((origin === 'bpm' || origin === 'BPM') && theValue.value) {
                    answerValue = theValue.value;
                }
            }
        }
    }

    return answerValue;
};
